var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:{
        'justify-content-center': _vm.centered
    }},[(_vm.prefix && _vm.value && _vm.computedField)?[_vm._v(" "+_vm._s(_vm.prefix)+" ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.computedField || '-')+" "),(_vm.suffix && _vm.value && _vm.computedField)?[_vm._v(" "+_vm._s(_vm.suffix)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }